import { render } from "./show-goods.vue?vue&type=template&id=18bc3f2c&scoped=true&ts=true"
import script from "./show-goods.vue?vue&type=script&lang=ts"
export * from "./show-goods.vue?vue&type=script&lang=ts"

import "./show-goods.vue?vue&type=style&index=0&id=18bc3f2c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bc3f2c"]])

export default __exports__